import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

import {
  Flex,
  FlexItem,
  Divider,
  SpacingVertical,
  SPACING_24,
  SPACING_32,
  Collapsible,
  Text
} from 'mailup-web-components'

import styled from '@emotion/styled'
import Header from './components/Header'
import SelectHeader from './components/SelectHeader'
import { InputEmail } from './components/InputEmail'
import { SelectFilter } from './components/SelectFilter'
import { SelectGroup } from './components/SelectGroup'


export const LAST_SELECTED_EMAIL = 'email'
export const LAST_SELECTED_FILTER = 'filter'
export const LAST_SELECTED_GROUP = 'group'

const SelectRecipient = ({
  groups,
  filters,
  filterGroups,
  lastEmails,
  lastFilters,
  lastGroups,
  lastTypeSelected,
  searchRecipientsCallback
}) => {
  const intl = useIntl()

  const [selectedRecipient, setSelectedRecipient] = useState(
    LAST_SELECTED_EMAIL
  )

  useEffect(() => {
    if (lastTypeSelected) {
      setSelectedRecipient(lastTypeSelected)
    }
  }, [lastTypeSelected])

  const handleSelectedRecipient = recipientType => {
    setSelectedRecipient(recipientType)
  }

  return (
    <Flex
      minHeight='calc(100vh - 145px)'
      width='100%'
      flexDirection='column'
      alignItems='center'
      padding='0 50px 65px 50px'
    >
      <Header />
      <Flex flexDirection='column' width='100%'>
        <FlexItem>
          <SelectHeader
            title={intl.formatMessage({ id: 'Load.MailupCommon.Email' })}
            isActive={selectedRecipient === LAST_SELECTED_EMAIL}
            onChangeActive={() => handleSelectedRecipient(LAST_SELECTED_EMAIL)}
          />
          <Collapsible collapsed={selectedRecipient !== LAST_SELECTED_EMAIL}>
            <InputEmail
              lastEmails={lastEmails}
              searchRecipientsCallback={searchRecipientsCallback}
            />
          </Collapsible>

          <SpacingVertical variant={SPACING_24} />
          <Divider />
          <SpacingVertical variant={SPACING_32} />
        </FlexItem>
        <FlexItem>
          <SelectHeader
            title={intl.formatMessage({ id: 'Load.Common.Filter' })}
            isActive={selectedRecipient === LAST_SELECTED_FILTER}
            onChangeActive={() => handleSelectedRecipient(LAST_SELECTED_FILTER)}
          />

          <Collapsible collapsed={selectedRecipient !== LAST_SELECTED_FILTER}>
            <SelectFilter
              options={filters}
              optionGroups={filterGroups}
              lastFilters={lastFilters}
              searchRecipientsCallback={searchRecipientsCallback}
            />
          </Collapsible>

          <SpacingVertical variant={SPACING_24} />
          <Divider />
          <SpacingVertical variant={SPACING_32} />
        </FlexItem>
        <FlexItem>
          <SelectHeader
            title={intl.formatMessage({ id: 'Load.Common.Group' })}
            isActive={selectedRecipient === LAST_SELECTED_GROUP}
            onChangeActive={() => handleSelectedRecipient(LAST_SELECTED_GROUP)}
          />

          <Collapsible collapsed={selectedRecipient !== LAST_SELECTED_GROUP}>
            <SelectGroup
              groups={groups}
              lastGroups={lastGroups}
              searchRecipientsCallback={searchRecipientsCallback}
            />
          </Collapsible>

          <SpacingVertical variant={SPACING_24} />
          <Divider />
          <SpacingVertical variant={SPACING_32} />
        </FlexItem>
      </Flex>
    </Flex>
  )
}

export default SelectRecipient

SelectRecipient.defaultProps = {
  groups: [],
  filters: [],
  lastEmails: [],
  lastFilters: [],
  lastGroups: []
}

SelectRecipient.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object),
  filters: PropTypes.arrayOf(PropTypes.object),
  lastEmails: PropTypes.arrayOf(PropTypes.object),
  lastFilters: PropTypes.arrayOf(PropTypes.object),
  lastGroups: PropTypes.arrayOf(PropTypes.object),
  searchRecipientsCallback: PropTypes.func,
  lastTypeSelected: PropTypes.any,
  filterGroups: PropTypes.any
}

export const StyledLabel = styled(Text)`
  white-space: nowrap;
`
